import {Component} from '@angular/core';

@Component({
    selector: 'dl-fault-sensor',
    templateUrl: './fault-sensor.component.html'
})
export class FaultSensorComponent {
    public static $name: string = 'faultSensor';
}
